
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ExceptionService, UtilsService } from '../../../xform-compat';
import { Observable } from 'rxjs';


/**
 * Data Service for follow/unFollow companies
 */
@Injectable({
  providedIn: 'root'
})
export class FollowCompanyService {

  private url = '/api/rms/companies';
  constructor(
    private http: HttpClient,
    private exceptionService: ExceptionService,
    private utilsService: UtilsService
  ) { }

  public follow (companyId: number, companyList?: Array<number>) {
    return this.http
      .post(`${this.url}/${companyId}/follow/me`, {companyIds: companyList}).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  public unFollow (companyId: number) {
    return this.http
      .delete(`${this.url}/${companyId}/follow/me`).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Returns the list of companies not followed by the logged in user
   * @param {object} params: params for the filter
   * @returns {Observable<any>}: the response form the API
   */
  public getUnFollowedCompanies (params?: object) {
    const httpParams: HttpParams = this.utilsService.generateParams(params);
    return this.http
      .get(`${this.url}/unfollow/me`, {params: httpParams}).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  public getAllFollowed(params?: object): Observable<any> {
    const httpParams: HttpParams = this.utilsService.generateParams(params);
    return this.http.get(`${this.url}/follow/all`, {params: httpParams}).pipe(
        catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

}
